<template>
  <modal name="modalAddParticipant" class="custom-modal add-participant-modal" :width='"605px"' :height="'auto'"
         :scrollable="true" @before-open="beforeOpen" @before-close="beforeClose" :clickToClose="false">
    <div class="modal-padding">
      <div class="modal-close-img" @click="hideModal()">
        <div class="icon-close"></div>
      </div>
      <div class="title">add participant</div>
      <div class="participant-info" v-for="(validator, index) in validators">
        <div class="row">
          <div class="col-md-12">
            <Validator :validator="validator" :participant="participant" @clicked="onClickChild" ref="formValidation"></Validator>
          </div>
        </div>
        <!--<div class="email-employee-container">
          <div class="row">
            <div class="col-md-8">
              <div class="ap-field-input-wrapper">
                <div class="title-field">Email</div>
                <div class="ap-input-wrapper">
                  <input type="text" v-model="participant.email" class="input field-input" v-validate="'required|email'" data-vv-as="email" name="participantEmail" placeholder="sample@email.com">
                </div>
                <div class="error-message">{{ errors.first('participantEmail') }}</div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="ap-field-input-wrapper">
                <div class="title-field">Employee Id</div>
                <div class="ap-input-wrapper">
                  <input type="text" v-model="participant.employeeId" v-validate="'required'" data-vv-as="employee ID" name="employeeId" class="input field-input" placeholder="Enter your ID">
                </div>
                <div class="error-message">{{ errors.first('employeeId') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="select-more-services col-md-12" v-if="!isEdit">
            <div class="title-field" v-if="!fromBiometric">Add more service</div>
            <div class="checkbox-container">
              <b-form-checkbox v-if="!fromBiometric" v-model="participant.hasBiometric" class="ap-checkbox-group add-more-services-checkbox">Add biometric screening</b-form-checkbox>
              <b-form-checkbox v-else-if="fromBiometric && eventDetail.eventSlotGroupsFLuShotOnly && eventDetail.eventSlotGroupsFLuShotOnly.length > 0" v-model="participant.hasFluShot" class="ap-checkbox-group add-more-services-checkbox">Add flu shot</b-form-checkbox>
              <span v-else></span>
            </div>
          </div>
        </div>-->
      </div>
      <div class="btn-add-container">
        <button class="ap-btn secondary btn-cancel" @click="hideModal">Cancel</button>
        <button class="ap-btn primary btn-add-participant" @click="addOrEditParticipant" :disabled="!isValid">{{isEdit ? 'Update' : 'Add'}}</button>
      </div>
    </div>
  </modal>
</template>
<script>
  import 'vue-awesome/icons/search';
  import Icon from 'vue-awesome/components/Icon';
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import Validator from '../../validators/ValidatorField.vue';
  // const _ = require('lodash');
  // import constant from '../../_consts';

  export default {
    name: 'modalAddParticipant',
    components: {
      Icon,
      Validator
    },
    props: {
      requestUpdateTable: {
        type: Function
      }
    },
    data () {
      return {
        slot: {},
        eventDetail: {},
        participant: {
          firstName: '',
          lastName: '',
          email: '',
          dob: '',
          employeeId: '',
          gender: '',
          hasBiometric: false,
          hasFluShot: 0
        },
        fromBiometric: true,
        isEdit: false,
        validators: {},
        isValid: false
      }
    },
    methods: {
      onClickChild (data) {
        this.isValid = data.isValid;
        this.participant = data;
      },
      hideModal () {
        if (this.participant) {
          // this.slot.eventParticipants = {};
        }
        this.$modal.hide('modalAddParticipant');
      },
      beforeOpen (obj) {
        let data = obj.params;
        this.slot = data.slot;
        this.eventDetail = data.eventDetail;
        this.isEdit = this.slot.isEdit;
        this.fromBiometric = this.slot.fromBiometric;
        this.participant.hasBiometric = this.slot.hasBiometric;
        this.participant.hasFluShot = this.slot.hasFluShot;
        this.getValidatorsByEventId(data.eventId).then(response => {
          this.validators = response.validators;
        });
        if (this.slot.eventParticipants && this.slot.eventParticipants.length > 0) {
          let part = this.slot.eventParticipants[0];
          this.participant = {...part};
        }
      },
      beforeClose () {
        this.participant = {};
      },
      async addOrEditParticipant () {
        let that = this;
        for (let i = 0; i < that.$refs.formValidation.length; i++) { // validating each field
          await that.$refs.formValidation[i].validateData().then(result => {
            if (!result) {
              that.isValid = result;
            }
          });
        }
        if (that.isValid) { // check if all fields are not empty
          if (that.slot.eventParticipants === null) {
            that.slot.eventParticipants = [that.participant];
          } else {
            that.slot.eventParticipants[0] = that.participant;
          }
          let body = {
            slotId: that.slot.id,
            eventId: that.slot.eventId,
            hasBiometric: that.participant.hasBiometric === true,
            hasFluShot: that.participant.hasFluShot,
            eventParticipant: {
              ...that.participant
            },
            isUpdating: this.isEdit
          };
          that.addParticipant(body).then(response => {
            // that.updateSlot(response);
            if (!(response.statusCodes === 'BAD_REQUEST') && !response.message) {
              this.$toast.success('Successfully adding participant.', '', {
                ...this.$toastOpt.optSuccess
              });
              this.$modal.hide('modalAddParticipant');
              that.requestUpdateTable();
            } else {
              this.$toast.success(response.message, '', {
                ...this.$toastOpt.optError
              });
            }
          });
        }
      },
      updateSlot (res) { // this function may not be used in the future
        if (res.message !== null) {
          this.slot.eventParticipants = {};
          this.$toast.success(res.message, '', {
            ...this.$toastOpt.optError
          });
        } else {
          let slotDto = res.eventSlotDto;
          this.slot.eventParticipants = slotDto.eventParticipants;
          this.slot.status = slotDto.status;
          this.slot.numParticipant = slotDto.numParticipant;
          this.$toast.success('Successfully adding participant.', '', {
            ...this.$toastOpt.optSuccess
          });
          this.$modal.hide('modalAddParticipant');
        }
      },
      ...mapActions({
        addParticipant: 'ACTION_ADD_PARTICIPANT',
        getValidatorsByEventId: 'ACTION_GET_VALIDATORS_BY_EVENT_ID'
      }),
      ...mapMutations({
      })
    },
    computed: {
      ...mapGetters({
        getIsLoadingModal: 'GETTER_IS_LOADING_MODAL'
      })
    }
  }
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';

  .custom-modal {
    .modal-padding {
      padding: 26px 24px 30px 24px;
      .modal-close-img {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        .icon-close {
          margin: 1.5px 1.5px;
          width: 27px;
          height: 27px;
          color: @grey-3;
          background-color: @grey-3;
          -webkit-mask: url('../../../../static/img/action-close.svg') no-repeat center;
          mask: url('../../../../static/img/action-close.svg') no-repeat center;
          background: url('../../../../static/img/action-close-grey.svg');
        }
      }
      .first-name-and-last-name-text-box {
        height: 48px;
        width: 266px;
        border: 1px solid #8E8E8E;
        border-radius: 4px;
        background-color: rgba(255,255,255,0);
      }
      .email-text-box {
        height: 48px;
        width: 369px;
        border: 1px solid #8E8E8E;
        border-radius: 4px;
        background-color: rgba(255,255,255,0);
      }
      .employee-text-box {
        height: 48px;
        width: 162px;
        border: 1px solid #8E8E8E;
        border-radius: 4px;
        background-color: rgba(255,255,255,0);
      }
      .title {
        color: @black-3;
        font-family: @font-family-main;
        font-size: 32px;
        font-weight: 800;
        letter-spacing: -1px;
        line-height: 40px;
        text-transform: uppercase;
        margin-bottom: 20px;
      }
      .text {
        color: @grey-8;
        font-family: @font-family-main;
        font-size: 16px;
        line-height: 24px;
        height: 45px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AddParticipantModal.vue?edebdcac